// extracted by mini-css-extract-plugin
export default {"channelsPage":"channels-page_channelsPage__SJ-kJ","table":"channels-page_table__jjvLs","scroll":"channels-page_scroll__6x81e"};